import { module as m } from 'modujs';

export default class extends m {
    constructor(m) {
        super(m);

        // DOM
        this.dom = {};
        this.dom.openMobile = document.querySelector('.open-mobile');

        // FUNC
        this.handleScroll = this.handleScroll.bind(this);
    }

    /**
     * INIT
     */
    init() {
        this.dom.openMobile.addEventListener('click', () => {
            this.call('show', '', 'MenuMobile');
        })
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }

    /**
     * START
     */
    start() {}

    /**
     * DESTROY
     */
    destroy() {}

    handleScroll(event) {
        if(window.scrollY > 10)
            this.el.classList.add('is-scrolling');
        else
            this.el.classList.remove('is-scrolling');
    }
}
